import { Stack, IconButton } from '@fluentui/react';
import React from 'react';
import WidgetCard from './components/WidgetCard';
import AddWidgets from './components/AddWidgets';
import { useIsUserAloneInOwnPersonalRoom, useWidgetsList, useCurrentWidgetIndex } from 'features/Rooms/PersonalMeetingCorner/states/hooks';
import { navigationButtonStyles, selectedWidgetsStyles, widgetsContainerStyles } from './SelectedWidgets.styles';

const SelectedWidgets: React.FC = () => {
    const isUserAloneInOwnPersonalRoom = useIsUserAloneInOwnPersonalRoom();
    const [widgetsList, setWidgetsList] = useWidgetsList();
    const [currentIndex, setCurrentIndex] = useCurrentWidgetIndex();
    const maxVisibleWidgets = isUserAloneInOwnPersonalRoom ? 2 : 3;

    const handleDelete = (id: string) => {
        setWidgetsList(widgetsList.filter((widget) => widget.id !== id));
        // Reset currentIndex if we're at the end and delete the last widget
        if (currentIndex > 0 && currentIndex >= widgetsList.length - maxVisibleWidgets) {
            setCurrentIndex(Math.max(0, widgetsList.length - maxVisibleWidgets - 1));
        }
    };

    const handlePrevious = () => {
        setCurrentIndex(Math.max(0, currentIndex - 1));
    };

    const handleNext = () => {
        setCurrentIndex(Math.min(widgetsList.length - maxVisibleWidgets, currentIndex + 1));
    };

    const visibleWidgets = widgetsList.slice(currentIndex, currentIndex + maxVisibleWidgets);
    const showNavigation = widgetsList.length > maxVisibleWidgets;

    return (
        <Stack className={selectedWidgetsStyles}>
            {showNavigation && currentIndex > 0 && (
                <IconButton
                    iconProps={{ iconName: 'ChevronLeft' }}
                    onClick={handlePrevious}
                    className={navigationButtonStyles}
                    styles={{ root: { left: '6px' } }}
                />
            )}

            <Stack className={widgetsContainerStyles}>
                {visibleWidgets.map((widget) => (
                    <WidgetCard key={widget.id} widget={widget} onDelete={handleDelete} />
                ))}
                {isUserAloneInOwnPersonalRoom && <AddWidgets />}
            </Stack>

            {showNavigation && currentIndex < widgetsList.length - maxVisibleWidgets && (
                <IconButton
                    iconProps={{ iconName: 'ChevronRight' }}
                    onClick={handleNext}
                    className={navigationButtonStyles}
                    styles={{ root: { right: '6px' } }}
                />
            )}
        </Stack>
    );
};

export default SelectedWidgets;
